import { useMemo, useEffect } from "react";

import useAZZKUTopics from "hooks/AZZKU/useAZZKUTopics";
import useAZZKUVoivodeships from "hooks/AZZKU/useAZZKUVoivodeships";
import useAZZKUAvailableTerritories from "hooks/AZZKU/useAZZKUAvailableTerritories";

import ExpandableBox from "components/ExpandableBox";
import RadioGroup from "components/RadioGroup";
import CheckboxGroup from "components/CheckboxGroup";
import Select from "components/Select";

export default function AZZKUTopResultsSidebar({ params, errors, onChange }) {

   const { d: topics } = useAZZKUTopics( true );
   const { d: voivodeships } = useAZZKUVoivodeships();
   const { d: available_territories } = useAZZKUAvailableTerritories( params.variable_id );
   const only_country = available_territories?.length === 1 && available_territories?.[0] === "country";

   useEffect(() => {
      if ( !available_territories || available_territories.length === 2 ) return;
      if ( available_territories[0] === "country" ) onChange({ voivodeship_ids: [0]});
   }, [ available_territories ]);

   return (
      <div className="azzku-top-results-sidebar-filters box">

         <ExpandableBox
            extra_classes="mini"
            heading={ <strong style={{ display: "block", textAlign: "right"}}> Zwiń wszystko </strong> }
            style={{ border: 0, padding: 0 }}
         > 
            <ExpandableBox 
               default_open
               heading="Dane"
               extra_classes="mini"
            > 
               { topics && !!topics?.length &&
                  topics.map(({ label: topic_name, value: topic_id, variables }) => {
                     return (
                        <ExpandableBox
                           key={ topic_id }
                           heading={ topic_name }
                           default_open={ !!variables.find( v => +v.value === +params.variable_id )}
                           extra_classes="mini mini-inner"
                        >
                           <RadioGroup
                              name={ "variable_id_" + topic_id }
                              value={ params.variable_id }
                              buttons={ variables }
                              onChange={( n, v ) => onChange( "variable_id", v )}
                           />
                        </ExpandableBox>
                     )
                  })
               }
            </ExpandableBox>

            { voivodeships &&
               <ExpandableBox
                  heading="Obszar"
                  extra_classes="mini"
               >
                  <Select
                     name="territorial_scale"
                     value={ params.territorial_scale }
                     disabled={ available_territories?.length === 1 }
                     ariaLabel="Wybierz terytorium z listy rozwijanej"
                     options={[
                        { value: 1, label: "Polska" },
                        { value: 2, label: "Województwa" }
                     ]}
                     onChange={( n, v ) => onChange({
                        [n]: v,
                        voivodeship_ids: +v === 1 ? [0] : []
                     })}
                  />

                   { only_country &&
                     <div> Wyniki występują jedynie w skali krajowej </div>
                  }

                  { +params.territorial_scale === 2 &&
                     <>
                        <p> Wybierz 1 województwo: </p>
         
                        <CheckboxGroup
                           max={1}
                           name="voivodeship_ids"
                           value={ params.voivodeship_ids || []}
                           errors={ errors?.voivodeship_ids }
                           buttons={ voivodeships }
                           onChange={ onChange }
                        />
                     </>
                  }
               </ExpandableBox>
            }
         </ExpandableBox>
      </div>
   )
}